// Los avisos de un despacho Turbo (turbo_dispatches.warnings) en palabras. Un
// solo mapa para las pantallas de Turbo: un código que no esté acá se ve
// crudo, así que cada código nuevo del servidor (turboDispatchService) va acá.
export const TURBO_WARNING_LABEL: Record<string, string> = {
  GEO_PENDING: "sin ubicación del comprador",
  GEO_INVALID: "coordenadas del comprador imposibles",
  DEADLINE_PASSED: "entró vencido",
  OLD_PURCHASE: "compra de un día anterior",
  NO_CANDIDATES: "sin choferes disponibles",
  NO_MORE_CANDIDATES: "se agotaron los choferes",
  RINGS_EXHAUSTED: "nadie contestó",
  NOT_DISPATCHABLE: "se dejó de ofrecer: ya no estaba para retirar",
  MANUAL: "asignado a mano",
  FORCED: "forzado por el coordinador",
  DISABLED: "con el módulo Turbo apagado",
  OUT_OF_RADIUS: "fuera del radio",
  OUT_OF_WINDOW: "fuera de franja",
  UNASSIGNED: "le sacaron el chofer",
  DELIVERY_DELIVERED: "el envío figura entregado",
  DELIVERY_CANCELLED: "el envío figura cancelado",
};

export const turboWarning = (code: string) => TURBO_WARNING_LABEL[code] ?? code;
